export const EvaluationInfoEnum = {
EvaluationStepInfo: "EvaluationStepInfo",
EvaluationInfo: "EvaluationInfo",
ourLawInfo: "ourLawInfo"
};

export const EvaluationInfoType = Object.values(EvaluationInfoEnum);